import { render, staticRenderFns } from "./VasionCustomizableTextBox.vue?vue&type=template&id=49340a5c&scoped=true"
import script from "./VasionCustomizableTextBox.vue?vue&type=script&lang=js"
export * from "./VasionCustomizableTextBox.vue?vue&type=script&lang=js"
import style0 from "./VasionCustomizableTextBox.vue?vue&type=style&index=0&id=49340a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49340a5c",
  null
  
)

export default component.exports